// import { Amplitude } from 'gatsby-plugin-amplitude-analytics';


export const logEvent = (eventName, data, mixpanel = null) => {
    if(mixpanel) {
        mixpanel.track(eventName, data);
    }
    window.amplitude.logEvent(eventName, data);
}